import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import ReactLoading from "react-loading";

class Login extends Component {
  state = {
    username: "",
    password: "",
    error: "",
    click: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  login = () => {
    this.setState({
      click: true,
      error: "",
    });

    axios
      .post("login", {
        username: this.state.username,
        password: this.state.password,
      })
      .then((login) => {
        localStorage.setItem("user", JSON.stringify(login.data.data));
        window.location.replace(process.env.REACT_APP_EVIVESOMA);
      })
      .catch((error) => {
        window.localStorage.clear();
        this.setState({
          click: false,
          error: error.response?.data?.msg || "Authentification impossible. Veuillez vérifier vos informations.",
        });
      });
  };

  render() {
    const isLoading = this.state.click && !this.state.error;

    return (
      <div>
        <div className="modal fade pt-0" id="popupLogin" tabIndex="-1" aria-labelledby="popupLoginTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content evive-auth-modal">
              <button type="button" className="auth-close-btn" data-bs-dismiss="modal" aria-label="Fermer">
                <FeatherIcon icon="x" size={18} />
              </button>

              <div className="auth-modal-hero">
                <img src="/logo192.png" alt="EviveSoma" width="70" height="70" />
                <span className="eyebrow">Espace parent</span>
                <h5 id="popupLoginTitle">{process.env.REACT_APP_NAME || "EviveSoma"}</h5>
                <p>Connectez-vous pour consulter le suivi scolaire, les frais et les notifications.</p>
              </div>

              <form
                className="auth-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.login();
                }}
              >
                {this.state.error && (
                  <div className="auth-alert">
                    <FeatherIcon icon="alert-circle" size={16} />
                    <span>{this.state.error}</span>
                  </div>
                )}

                <div className="auth-field">
                  <label htmlFor="yourUsername">Téléphone</label>
                  <div>
                    <FeatherIcon icon="user" size={17} />
                    <input
                      type="number"
                      placeholder="Téléphone"
                      name="username"
                      value={this.state.username}
                      onChange={this.handleInput}
                      id="yourUsername"
                    />
                  </div>
                </div>

                <div className="auth-field">
                  <label htmlFor="yourPassword">Mot de passe</label>
                  <div>
                    <FeatherIcon icon="lock" size={17} />
                    <input
                      type="password"
                      name="password"
                      value={this.state.password}
                      onChange={this.handleInput}
                      id="yourPassword"
                    />
                  </div>
                </div>

                <button className="auth-submit-btn" type="submit" disabled={isLoading}>
                  {isLoading && <ReactLoading type="spokes" color="white" height={20} width={18} />}
                  <span>Connexion</span>
                </button>

                <p className="auth-help">
                  Vous n'avez pas un compte? <a href="#">Contactez votre école svp</a>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
